import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { Icon } from '@elfsight/widget-ui';
import { createReadableClass, getColorWithAlpha } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { useTags } from '../utils/use-tags';

export const LocationTagItem = ({ tagId }: { tagId: string }) => {
  const { textColor } = useSettings();
  const tags = useTags();

  const color = getColorWithAlpha(textColor, 0.5);
  const tag = tags?.find(({ id }) => id === tagId);

  if (!tag?.name) {
    return null;
  }

  const { name, icon } = tag;
  const [firstWord, ...rest] = name.split(' ');
  const restWords = rest.join(' ');

  return (
    <Tag _color={color}>
      <Show when={!!icon?.url} fallback={name}>
        <>
          <Start>
            <StyledIcon src={icon?.url} size={16} fill={color} alt="" />
            {firstWord}
          </Start>
          {restWords && ` ${restWords}`}
        </>
      </Show>
    </Tag>
  );
};

const Tag = styled.span.attrs({
  className: createReadableClass({
    component: 'location-tag-item'
  })
})<{ _color: string }>`
  margin-right: 12px;
  font-size: 13px;
  line-height: 22px;
  color: ${({ _color }) => _color};
`;

const StyledIcon = styled(Icon).attrs({
  className: createReadableClass({
    component: 'location-tag-item',
    element: 'icon'
  })
})`
  display: inline-block;
  margin-right: 2px;
  vertical-align: text-bottom;
`;

const Start = styled.span`
  white-space: nowrap;
`;
